import { Component, effect, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '@app/services/auth.service';
import { environment } from '@env';
import { TranslocoPipe } from '@jsverse/transloco';
import { Button } from 'primeng/button';
import { FloatLabel } from 'primeng/floatlabel';
import { InputText } from 'primeng/inputtext';
import * as Sentry from '@sentry/angular';

@Component({
  selector: 'app-login',
  imports: [ReactiveFormsModule, TranslocoPipe, Button, FloatLabel, InputText],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  standalone: true,
})
export class LoginComponent {
  private authService = inject(AuthService);
  private router = inject(Router);

  registrationUrl = environment.PRO_POINTS_REGISTRATION;

  isLoggedIn = effect(async () => {
    const isLoggedIn = await this.authService.isLoggedIn();
    if (isLoggedIn) {
      await this.router.navigate(['/']);
    }
  });
  form = new FormGroup({
    zipCode: new FormControl<string | null>(null, [Validators.required]),
    code: new FormControl<string | null>(null, [Validators.required, Validators.minLength(6), Validators.maxLength(6)]),
  });

  onInputChange() {
    this.form.setErrors(null);
  }

  showGlobalError() {
    this.form.setErrors({
      incorrect: true,
    });
  }

  public async loginWithCode() {
    const code = `${this.form.controls.zipCode.value}${this.form.controls.code.value}`;

    const response = await this.authService.loginWithCode(code);

    if (response.success) {
      await this.authService.loadUser();
      await this.router.navigate(['/chat']);
    } else {
      this.showGlobalError();

      const err = new Error(`Login with device code ${code} failed.`);
      console.error('[LoginComponent] Error during login:', err);
      Sentry.captureException(err, {
        tags: {
          location: 'LoginComponent',
          feature: 'Login',
          message: err.message,
        },
      });
    }
  }

  public loginWithProPoints() {
    this.authService.login();
  }
}
